import {Box} from "@mui/material";
import importedStyles from "../../Proactive/Utilities/campaignStyles";
import UpdateResourceForm from "./UpdateResourceForm";

export default function EditResource() {
    return (
        <>
            <Box sx={importedStyles.root}>
                <Box sx={styles.container}>
                    <Box sx={importedStyles.containerBody}>
                        <Box sx={importedStyles.header}>
                            Edit resource
                        </Box>
                        <UpdateResourceForm/>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

const styles = {
    container: {
        px: { xs: 2, sm: 6 },
        maxWidth: '700px',
        position: 'relative',
    },
}